import { RadioGroup, Stack } from "@chakra-ui/react";
import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

import {
  OptimizationTarget,
  PERIODS,
  PERIODS_CP,
} from "../../types/optimization-rule";
import { Field } from "../field";
import { Info } from "../info";
import { StepContent } from "./step-content";
import { OptimizationFormData } from "./types";

export function TimeframeStep() {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<OptimizationFormData>();
  const target = watch("target");

  const timeframeOptions = (
    target === OptimizationTarget.CP ? PERIODS_CP : PERIODS
  ).map((period) => ({
    label:
      period === 365
        ? "1 year"
        : period === 180
          ? "6 months"
          : `${period} days`,
    value: String(period),
    period,
  }));

  return (
    <StepContent
      title="Timeframe Selection"
      subtitle="Select the timeframe for predicting the likelihood to convert"
    >
      <Field invalid={!!errors.timeframe} errorText={errors.timeframe?.message}>
        <Controller
          name="timeframe"
          control={control}
          render={({ field }) => (
            <RadioGroup.Root
              value={field.value}
              onValueChange={(e) => field.onChange(e.value)}
              onBlur={field.onBlur}
              name={field.name}
              colorPalette="blue"
            >
              <Stack>
                {timeframeOptions.map((option) => (
                  <RadioGroup.Item key={option.value} value={option.value}>
                    <RadioGroup.ItemHiddenInput />
                    <RadioGroup.ItemIndicator />
                    <RadioGroup.ItemText>{option.label}</RadioGroup.ItemText>
                  </RadioGroup.Item>
                ))}
              </Stack>
            </RadioGroup.Root>
          )}
        />
      </Field>
      {target !== OptimizationTarget.CP && (
        <Info>We recommend 1 year for maximum predictive value.</Info>
      )}
    </StepContent>
  );
}
